import { useState } from "react";
import { PawPrint, Menu, X } from "lucide-react";

const LINKS = [
  { label: "Why Dogtopia", href: "#benefits", testid: "nav-link-benefits" },
  { label: "Economics", href: "#financials", testid: "nav-link-financials" },
  { label: "Process", href: "#process", testid: "nav-link-process" },
  { label: "Owners", href: "#testimonials", testid: "nav-link-testimonials" },
];

export function Nav({ onNavigate }) {
  const [open, setOpen] = useState(false);
  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    onNavigate(href);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-[#FBF9F5]/90 backdrop-blur-md border-b border-[#E4DFD3]">
      <nav className="mx-auto max-w-7xl px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <a href="#top" onClick={(e) => go(e, "#top")} className="flex items-center gap-2.5" data-testid="nav-brand-logo">
          <span className="w-9 h-9 rounded-full bg-[#0D3B3E] flex items-center justify-center">
            <PawPrint className="w-5 h-5 text-[#F7C948]" />
          </span>
          <span className="font-display font-extrabold text-xl text-[#0D3B3E] tracking-tight">
            Dogtopia<span className="text-[#FF6B4A]">.</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.testid}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={l.testid}
              className="text-sm font-medium text-[#5C6B6C] hover:text-[#0D3B3E] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#lead-form"
            onClick={(e) => go(e, "#lead-form")}
            data-testid="nav-cta-request-info"
            className="rounded-full bg-[#FF6B4A] hover:bg-[#E55636] text-white text-sm font-semibold px-5 py-2.5 transition-all hover:-translate-y-0.5 hover:shadow-lg"
          >
            Request Info
          </a>
        </div>

        <button
          className="md:hidden text-[#0D3B3E]"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-menu-button"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-[#FBF9F5] border-t border-[#E4DFD3] px-5 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a key={l.testid} href={l.href} onClick={(e) => go(e, l.href)} className="text-sm font-medium text-[#0D3B3E]">
              {l.label}
            </a>
          ))}
          <a
            href="#lead-form"
            onClick={(e) => go(e, "#lead-form")}
            className="rounded-full bg-[#FF6B4A] text-white text-sm font-semibold px-5 py-2.5 text-center"
          >
            Request Info
          </a>
        </div>
      )}
    </header>
  );
}
